// import { useMemo } from "react";
// import {usePermissions} from "./usePermission";
//
// export interface MenuModel {
//     label: string;
//     icon: string;
//     items?: {
//         label: string;
//         icon: string;
//         to: string;
//         permission?: string;
//     }[];
// }
//
// export const useFilteredMenu = (
//     menu: MenuModel[]
// ): MenuModel[] => {
//     const { hasPermission } = usePermissions();
//
//     return useMemo(() => {
//         return menu.reduce<MenuModel[]>((acc, group) => {
//             if (!group.items || group.items.length === 0) {
//                 acc.push(group);
//                 return acc;
//             }
//
//             const visibleItems = group.items.filter((item) => {
//                 if (!item.permission) return true;
//
//                 const [resource, action] = item.permission.split(":");
//                 return hasPermission(resource, action);
//             });
//
//             if (visibleItems.length > 0) {
//                 acc.push({
//                     ...group,
//                     items: visibleItems,
//                 });
//             }
//
//             return acc;
//         }, []);
//     }, [menu, hasPermission]);
// };

import { useMemo } from "react";
import { usePermissions } from "./usePermission";
import {useAuth} from "./useAuth";

export interface MenuModel {
    label: string;
    icon: string;
    items?: {
        label: string;
        icon: string;
        to: string;
        permission?: string;
    }[];
}

export const useFilteredMenu = (menu: MenuModel[]): MenuModel[] => {
    const { hasPermission } = usePermissions();
    const { user } = useAuth();

    return useMemo(() => {
        const isSuperAdmin = user?.permissions?.includes("all");

        return menu.reduce<MenuModel[]>((acc, group) => {
            if (!group.items || group.items.length === 0) {
                acc.push(group);
                return acc;
            }

            // Filter items
            const visibleItems = group.items.filter((item) => {
                if (!item.permission) return true;

                // ✅ Super admin can see everything
                if (isSuperAdmin) return true;

                const [resource, action] = item.permission.split(":");
                return hasPermission(resource, action);
            });

            if (visibleItems.length > 0) {
                acc.push({
                    ...group,
                    items: visibleItems,
                });
            }

            return acc;
        }, []);
    }, [menu, hasPermission, user]);
};